import React, { Component, Fragment } from 'react';
import { Row, Col, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, FormGroup, Label, Input, Progress, Button } from 'reactstrap';
import { HubConnectionBuilder } from '@aspnet/signalr';
import { BarChart, tasksColor, productivityColor, cycleTimesColor } from '../Shared/BarChart';
import { ProcessingTimes, CycleTimes, Wip, WipCosts, SpaceCosts, Productivity } from '../../Logic/resultResources';
import { getProgress, getProgressColorFor } from '../Shared/SharedUILogic';
import { API } from '../../Logic/API';
import '../Spacing.css';

export class PlayGameTab extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isDropdownOpen: false,
            selectedGame: { Name: "Spiel wählen" },
            groups: [],
            remainingDuration: 600,
            gameInfo: {
                DurationOfCurrentRound : 600,
                Round : 1
            },
            gameState: "Stopped"
        };
    }

    componentDidMount() {
        const hubConnection = new HubConnectionBuilder().withUrl("/hubs/gameplay").build();
        this.setState({ gameplayHub : hubConnection },
            () => {
                this.state.gameplayHub.start();
                this.registerCallbacksOn(this.state.gameplayHub);
            });
    }

    registerCallbacksOn(hub) {
        hub.on('GameProgressUpdate',
            update => {
                if (update.GameId !== this.state.selectedGame.Id) {
                    return;
                }
                this.setState({
                    remainingDuration: update.Remaining,
                    gameState : update.State,
                });
            });
        hub.on('GameSessionHostUpdate',
            update => {
                if (update.GameId !== this.state.selectedGame.Id) {
                    return;
                }
                this.setState({
                    remainingDuration: update.Remaining,
                    gameState: update.State,
                });
            });
        hub.on('GameUpdate',
            update => {
                if (update.GameId !== this.state.selectedGame.Id) {
                    return;
                }
                this.setState({
                    gameInfo: update
                });
            });
    }

    componentWillUnmount() {
        if (!this.gameSelected()) {
            return;
        }
        this.stopListeningTo(this.state.selectedGame);
    }

    listenTo(game) {
        this.state.gameplayHub.invoke('Register', game.Id);
    }

    stopListeningTo(game) {
        this.state.gameplayHub.invoke('Unregister', game.Id);
    }

    toggleDropdown() {
        this.setState(prevState => ({
            isDropdownOpen: !prevState.isDropdownOpen
        }));
    }

    selectGame(game) {
        if (this.gameSelected()) {
            this.stopListeningTo(this.state.selectedGame);
        }

        this.setState({ selectedGame: game });

        API.get(`/gamehost/games/${game.Id}`)
            .then(resp => resp.json())
            .then(data => {
                this.setState({
                    gameInfo: data,
                    remainingDuration: data.DurationOfCurrentRound,
                    gameState : data.State
                });
            })
            .catch(e => {

            });

        this.listenTo(game);

        API.get(`/gamehost/games/${game.Id}/groups`)
            .then(resp => resp.json())
            .then(data => {
                this.setState({ groups: data });
            })
            .catch(e => {

            });
    }

    gameSelected() {
        return this.state.selectedGame && this.state.selectedGame.Id;
    }

    changeDurationTo(value) {
        let duration = parseInt(value, 10);
        if (isNaN(duration)) {
            duration = "";
        }
        this.setState({
            remainingDuration: duration
        });
    }

    pauseGame() {
        let dto = {
            Action: "Pause"
        };
        this.sendAction(dto);
    }

    resumeGame() {
        let dto = {
            Action: "Resume",
            Duration: this.state.remainingDuration
        };
        this.sendAction(dto);
    }

    stopGame() {
        let dto = {
            Action : "Stop"
        }
        this.sendAction(dto);
    }

    startGame() {
        let dto = {
            Action: "Play",
            Duration: this.state.remainingDuration
        }
        this.sendAction(dto);
    }

    completeGame() {
        let dto = {
            Action: "Complete"
        };
        this.sendAction(dto);
    }

    sendAction(actionDto) {
        API.post(`/gamehost/games/${this.state.selectedGame.Id}/play`, actionDto);
    }

    isGameRunning() {
        return this.state.gameState === "Started";
    }

    isGamePaused() {
        return this.state.gameState === "Paused";
    }

    isGameStopped() {
        return this.state.gameState === "Stopped";
    }

    isGameFinished() {
        return this.state.gameState === "Finished";
    }

    renderLoadingDropdown() {
        return (
            <Dropdown disabled toggle={() => {}}>
                <DropdownToggle caret>
                    Laden...
                </DropdownToggle>
            </Dropdown>
        );
    }

    renderName(game) {
        return `${game.Name} (${new Date(game.CreatedAtUtc).toLocaleDateString('de-CH')})`;
    }

    renderDropdown() {
        if (this.props.isLoadingGames) {
            return this.renderLoadingDropdown();
        }
        return (
            <Dropdown direction="right" isOpen={this.state.isDropdownOpen} toggle={() => this.toggleDropdown()}>
                <DropdownToggle color="primary" caret>
                    {this.state.selectedGame.Name}
                </DropdownToggle>
                <DropdownMenu>
                    {this.props.games.filter(g => g.IsOpen).map(g =>
                        <DropdownItem key={g.Id} onClick={() => this.selectGame(g)}>{this.renderName(g)}</DropdownItem>
                    )}
                </DropdownMenu>
            </Dropdown>
        );
    }

    renderDurationComponent() {
        if (this.isGameRunning()) {
            let progress = getProgress(this.state.remainingDuration, this.state.gameInfo.DurationOfCurrentRound);
            return (
                <Row>
                    <Col xs="4" >
                        <p className="text-right">{this.state.remainingDuration} Sekunden</p>
                    </Col>
                    <Col xs="8" >
                    <Progress color={getProgressColorFor(progress)}
                            value={progress}></Progress>
                    </Col>
                </Row>
            );
        }
        return (
            <Input type="number" value={this.state.remainingDuration} placeholder="Dauer" onChange={e => this.changeDurationTo(e.target.value)} disabled={!this.gameSelected()}/>
            );
    }

    renderGameActionButtons() {
        if (this.isGameFinished()) {
            return (
                <Col>
                    {this.renderActionButton("Fertig", () => "primary", () => this.completeGame())}
                </Col>);
        }
        if (this.isGameRunning()) {
            return (
                <Col>
                    {this.renderActionButton("Pause", () => "warning", () => this.pauseGame())}
                </Col>);
            }
        if (this.isGamePaused()) {
            return (
                <Fragment>
                    <Col>
                        {this.renderActionButton("Weiter", () => "success", () => this.resumeGame())}
                    </Col>
                    <Col>
                        {this.renderActionButton("Stop", () => "danger", () => this.stopGame())}
                    </Col>
                </Fragment>
            );
        }
        if (this.state.gameInfo.Round < 2) {
            return (
                <Col>
                    {this.renderActionButton("Start", () => "success", () => this.startGame())}
                </Col>    
                );
            }
        return (
            <Col>
                {this.renderActionButton("Runde starten", () => "success", () => this.startGame())}
            </Col>    
            );
    }
        
    renderActionButton(label, colorFunc, clickFunc) {
        return (<Button color={colorFunc()} block size="xl" onClick={clickFunc} disabled={!this.gameSelected()}>{label}</Button>);
    }

    render() {
        let gameDropdown = this.renderDropdown();
        let durationComponent = this.renderDurationComponent();
        let gameActionButton = this.renderGameActionButtons();

        return (
            <Fragment>
                <Row className="space-top">
                    <Col>
                        {gameDropdown}
                    </Col>
                </Row>
                <Row className="space-top">
                    <Col>
                        <FormGroup>
                            <Label>Dauer der Runde [Sekunden]</Label>
                            {durationComponent}
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Label>Runde: {this.state.gameInfo.Round}</Label>
                    </Col>
                </Row>
                <Row className="space-top">
                    {gameActionButton}
                </Row>
                {this.renderCharts()}
            </Fragment>
        );
    }

    renderCharts() {
        return (
            <Fragment>
                {this.state.groups.map(g => 
                    this.renderGroupCharts(g)
                    )}
            </Fragment>
        );
    }

    renderGroupCharts(group) {
        return (
            <Fragment>
                <Row className="space-top">
                    <Col><h3 className="text-left font-weight-bold">{group.Name}</h3></Col>
                </Row>
                <Row>
                    {this.renderChart(group.Id, "Summe der Prozesszeiten", ProcessingTimes, tasksColor)}
                    {this.renderChart(group.Id, "Produktionsleistung", Productivity, productivityColor, true)}
                    {this.renderChart(group.Id, "Materialeinsatz (WIP)", Wip, tasksColor)}
                </Row>
                <Row>
                    {this.renderChart(group.Id, "Durchlaufzeit", CycleTimes, cycleTimesColor)}
                    {this.renderChart(group.Id, "Platzbedarf", SpaceCosts, tasksColor)}
                    {this.renderChart(group.Id, "Materialeinsatz (Kosten)", WipCosts, tasksColor)}
                </Row>
            </Fragment>
            );
    }

    renderChart(groupId, label, resource, getColor, grouped) {
        if (!this.gameSelected()) {
            return (<Col></Col>);
        }
        return (
            <Col xs="12" lg="4">
                <BarChart key={groupId + resource} label={label} resource={resource} getColor={getColor} grouped={grouped} gameId={this.state.selectedGame.Id} groupId={groupId} height={300}/>
            </Col>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Admin/PlayGameTab.jsx